import React, { Component } from "react";
import Ink from "react-ink";
import { getAssetUrl } from "../../../helpers/getAssetUrl";
import { Drawer } from "@material-ui/core";

class CustomizationV3 extends Component {
    state = {
        open: false,
        update: true,
        addonQuantities: {},
    };

    componentDidMount() {
        this.initializeAddonQuantities();
    }

    initializeAddonQuantities = () => {
        const { product } = this.props;
        let addonQuantities = {};
        Object.keys(product.addons).forEach((category) => {
            product.addons[category].forEach((addon) => {
                addonQuantities[addon.id] = 0;
            });
        });
        this.setState({ addonQuantities });
    };

    isAddonInCart = (addonId) => {
        const { cartProducts } = this.props;
        for (let cartItem of cartProducts) {
            if (cartItem.selectedaddons && cartItem.selectedaddons.some(addon => addon.addon_id === addonId)) {
                return true;
            }
        }
        return false;
    };

    showQuantity = (addonId) => {
        const { cartProducts } = this.props;
        for (let cartItem of cartProducts) {
            if (cartItem.selectedaddons) {
                for (let addon of cartItem.selectedaddons) {
                    if (addon.addon_id === addonId) {
                        return cartItem.quantity;  // Returning the cart item's quantity
                    }
                }
            }
        }
        return 0;
    };

    increaseAddonQuantity = (addon, product) => {
        const { addonQuantities } = this.state;
        addonQuantities[addon.id] += 1;
        this.setState({ addonQuantities });
        this._submitAddon(addon, product);
    };

    decreaseAddonQuantity = (addon, product) => {
        const { cartProducts, updateCart } = this.props;
        const { addonQuantities } = this.state;
        addonQuantities[addon.id] -= 1;

        cartProducts.forEach((cp, cpIndex) => {
            if (cp.id === product.id) {
                if (cp.selectedaddons) {
                    cp.selectedaddons.forEach((selectedAddon, index) => {
                        if (selectedAddon.addon_id === addon.id) {
                            if (cp.quantity === 1) {
                                // if quantity is 1, remove the product from the cart
                                cartProducts.splice(cpIndex, 1);
                            } else {
                                // else decrement the quantity by 1
                                cp.quantity -= 1;
                            }
                        }
                    });
                }
            }
        });

        this.setState({ addonQuantities });
        this.props.forceUpdate();
        updateCart(cartProducts);
    };

    _submitAddon = (addon, product) => {
        console.log('🎯 CustomizationV3: Submitting addon', { addon, product });
        let addons = {
            selectedaddons: [
                {
                    addon_category_name: addon.addon_category.name,
                    addon_id: addon.id,
                    addon_name: addon.name,
                    price: addon.price,
                    addon_category_id: addon.addon_category.id
                },
            ],
        };
        // Create a new product object properly - don't mutate
        const productWithAddon = Object.assign({}, product, addons);
        productWithAddon.quantity = 1;
        console.log('🎯 Final product with addon:', productWithAddon);
        this.props.addProduct(productWithAddon);
        this.props.forceUpdate();
    };

    _removeAddon = (addon, product) => {
        const { cartProducts } = this.props;
        const index = cartProducts.findIndex((p) => p.id === product.id);

        if (index >= 0) {
            const cartItem = cartProducts[index];
            if (cartItem.selectedaddons) {
                const addonIndex = cartItem.selectedaddons.findIndex((a) => a.addon_id === addon.addon_id);
                if (addonIndex >= 0) {
                    cartItem.selectedaddons.splice(addonIndex, 1);
                    if (cartItem.selectedaddons.length === 0 && cartItem.quantity === 1) {
                        cartProducts.splice(index, 1);
                    } else {
                        cartItem.quantity -= 1;
                    }
                    localStorage.removeItem("appliedCoupon");
                    localStorage.removeItem("couponAppliedAmount");
                }
            }
        }
    };

    // _processAddons = (product) => {
    //     const { addonQuantities } = this.state;
    //     let selectedAddons = [];

    //     Object.keys(addonQuantities).forEach((addonId) => {
    //         if (addonQuantities[addonId] > 0) {
    //             let addon = this.findAddonById(addonId, product);
    //             if (addon) {
    //                 selectedAddons.push({
    //                     addon_category_name: addon.addon_category_name,
    //                     addon_id: addon.id,
    //                     addon_name: addon.name,
    //                     price: addon.price,
    //                 });
    //             }
    //         }
    //     });

    //     this.props.addProduct(Object.assign({ selectedaddons: selectedAddons }, product));
    // };

    findAddonById = (addonId, product) => {
        for (let category of Object.keys(product.addons)) {
            for (let addon of product.addons[category]) {
                if (addon.id === addonId) {
                    return addon;
                }
            }
        }
        return null;
    };

    handlePopupOpen = () => {
        this.setState({ open: true });
        this.rerenderInterval = setInterval(() => {
            this.props.forceUpdate();
        }, 100);
    };

    handlePopupClose = () => {
        this.setState({ open: false });
        this.props.forceUpdate();
        clearInterval(this.rerenderInterval);
    };

    componentWillUnmount() {
        clearInterval(this.rerenderInterval);
    };

    getTotalAddonQuantity = (productId) => {
        const { cartProducts } = this.props;
        let totalQuantity = 0;

        const cartItems = cartProducts.filter(cp => cp.id === productId);
        cartItems.forEach(cartItem => {
            totalQuantity += cartItem.quantity || 1;  // Assuming each cart item has a quantity of at least 1
        });

        return totalQuantity;
    }

    render() {
        const { product, cartProducts } = this.props;
        const isItemExistInCart = (item_id) => {
            return cartProducts.some(cartItem => cartItem.id === item_id);
        }

        return (
            <React.Fragment>
                {isItemExistInCart(product.id) ? (
                    <React.Fragment>
                    <button
                        onClick={this.handlePopupOpen}
                        type="button"
                        className="btn btn-add-remove btn-list-item-m"
                        style={{
                            color: localStorage.getItem("cartColor-bg"),
                        }}
                    >
                        <span className="btn-dec"></span>
                    </button>
                    <button type="button" className="btn btn-quantity btn-list-item-q">
                    {this.getTotalAddonQuantity(product.id)}
                    </button>
                    <button
                        type="button"
                        className="btn btn-add-remove btn-list-item-p"
                        style={{ color: localStorage.getItem("cartColor-bg") }}
                        onClick={this.handlePopupOpen}
                    >
                        <span className="btn-inc">+</span>
                    </button>
                    </React.Fragment>
                ) : (
                    <button
                        type="button"
                        className="btn btn-success"
                        style={{ color: localStorage.getItem("cartColor-bg") }}
                        onClick={this.handlePopupOpen}
                    >
                        Add
                        <span className="E1J0B" aria-hidden="true"></span>
                    </button>
                )}
                <Drawer anchor="bottom" className="bottom-sheet address-bottom-sheet" open={this.state.open} onClose={this.handlePopupClose}>
                    <div className="_1C9MZ _37xF_ _1EtzI" style={{
                        backgroundColor: localStorage.getItem("customizationDrawerBackgroundColor") || "transparent",
                    }}>
                        <div className="glG8N" style={{
                            backgroundColor: localStorage.getItem("customizationDrawerBackgroundColor") || "transparent",
                        }}>
                            <div className="_3pF6k" style={{
                                backgroundColor: localStorage.getItem("customizationDrawerContentBackgroundColor") || "#ffffff",
                            }}>
                                <div className="_1ZvQ3" style={{
                                    backgroundColor: localStorage.getItem("customizationDrawerImageBackgroundColor") || "#ffffff",
                                }}>
                                    {product.image && <img src={getAssetUrl(product.image)} className="_3svd9" />}
                                </div>
                                <div className="_1TDkx">
                                    {product.name}
                                    {product.price > 0 && (
                                        <span className="_3Qs0i">
                                            - {localStorage.getItem("currencySymbolAlign") === "left" && localStorage.getItem("currencyFormat")}
                                            {parseFloat(product.price)}
                                            {localStorage.getItem("currencySymbolAlign") === "right" && localStorage.getItem("currencyFormat")}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="_1LLwX">
                                {Object.keys(product.addons).map((category) => (
                                    <React.Fragment key={product.addons[category][0].addon_category.id}>
                                        <div className="_2qxe4" key={product.addons[category][0].addon_category.id}>
                                            {product.addons[category][0].addon_category.name}
                                        </div>
                                        <div>
                                            {product.addons[category].length && (
                                                <React.Fragment>
                                                    {product.addons[category].map((addon) => (
                                                        <React.Fragment key={addon.id}>
                                                            <div className="form-group addon-list">
																<label className="text addon-label" htmlFor={addon.name}>
																	<span className="custom-addon-label-name">
																		{addon.name}
																	</span>
																	<br />
																	<span className="addon-label-price font-weight-bold">
																		{localStorage.getItem("hidePriceWhenZero") === "true" && addon.price === "0.00" ? null : (
																			<React.Fragment>
																				{localStorage.getItem("currencySymbolAlign") === "left" &&
																					localStorage.getItem("currencyFormat")}
																				{addon.price}
																				{localStorage.getItem("currencySymbolAlign") === "right" &&
																					localStorage.getItem("currencyFormat")}
																			</React.Fragment>
																		)}
																	</span>
																	{addon.old_price && addon.old_price > 0 && (
																		<span
																			className="price-percentage-discount ml-1"
																			style={{
																				color: localStorage.getItem("cartColorBg"),
																			}}
																		>
																			{parseFloat(
																				((parseFloat(addon.old_price) - parseFloat(addon.price)) /
																					parseFloat(addon.old_price)) *
																				100
																			).toFixed(0)}
																			{localStorage.getItem("itemPercentageDiscountText")}
																		</span>
																	)}
																	<br />
																	<span className="strike-text addon-label-price">
																		{localStorage.getItem("hidePriceWhenZero") === "true" && addon.old_price === "0.00" ? null : (
																			<React.Fragment>
																				{localStorage.getItem("currencySymbolAlign") === "left" &&
																					localStorage.getItem("currencyFormat")}
																				{addon.old_price}
																				{localStorage.getItem("currencySymbolAlign") === "right" &&
																					localStorage.getItem("currencyFormat")}
																			</React.Fragment>
																		)}
																	</span>
																</label>
                                                                <div className="btn-group btn-group-sm draw-addon-right">
                                                                {this.isAddonInCart(addon.id) ? (
                                                                    <React.Fragment>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-add-remove btn-list-item-m"
                                                                            style={{ color: localStorage.getItem("cartColor-bg") }}
                                                                            onClick={() => this.decreaseAddonQuantity(addon, product)}
                                                                        >
                                                                            <span className="btn-dec"></span>
                                                                            <Ink duration="500" />
                                                                        </button>
                                                                        <button type="button" className="btn btn-quantity addon-btn-quantity btn-list-item-q">
                                                                            {this.showQuantity(addon.id)}
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-quantity btn-list-item-q"
                                                                            style={{ color: localStorage.getItem("cartColor-bg") }}
                                                                            onClick={() => this.increaseAddonQuantity(addon, product)}
                                                                        >
                                                                            <span className="btn-inc">+</span>
                                                                            <Ink duration="500" />
                                                                        </button>
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-add-remove btn-custom-add btn-list-item-add"
                                                                        style={{ color: localStorage.getItem("cartColor-bg") }}
                                                                        onClick={() => {
                                                                            addon.quantity = 1;
                                                                            this._submitAddon(addon, product);
                                                                        }}
                                                                    >
                                                                        Add
                                                                    </button>
                                                                )}
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    ))}
                                                </React.Fragment>
                                            )}
                                        </div>
                                    </React.Fragment>
                                ))}
                            </div>
                            <div className="_2SVSR">
                                <div className="_2jmtx" onClick={() => {
                                    this.handlePopupClose();
                                }}>
                                    <span className="_3EnLm">{localStorage.getItem("customizationDoneBtnText")}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </Drawer>
            </React.Fragment>
        );
    }
}

export default CustomizationV3;
